import type { Role } from "@/rvapi";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({ role: "", email: "", loading: true }),
  actions: {
    setRole(roleData: Role) {
      this.role = roleData.role;
      this.email = roleData.email;
      this.loading = false;
    },
  },
});
